module.exports = __webpack_public_path__ + "static/logo-91601b52d73e58605a8d601fa1596fa1.png";